import {
  IDeviceItem,
  IDevices,
  ISlides,
  ITechCard,
  ITechnology,
  TechnologyCategories,
} from '@vfit/consumer/data-access';
import { ITechnologyDetailsProps } from './technologyCards.models';

export const organizeTechnologyCardModal = (cmsTechConfig: ITechCard) => {
  const dataToReturn: ITechnologyDetailsProps = {
    title: cmsTechConfig?.technology?.card?.title || '',
    subtitle: cmsTechConfig?.technology?.detail?.subtitle || '',
    firstDescription: cmsTechConfig?.technology?.detail?.description?.textSimple || '',
    secondDescription: cmsTechConfig?.technology?.detail?.description?.textHtml || '',
    imageSrc: cmsTechConfig?.technology?.detail?.description?.image || '',
    accordions: cmsTechConfig?.technology?.detail?.accordion?.map((accordion) => ({
      description: accordion?.description || '',
      title: accordion?.title || '',
    })),
  };

  return dataToReturn;
};

export const organizeTechCardsProductDetail = (
  aemTechnologyData: ITechCard | undefined,
  tecnologyMappedCategory: string,
): ISlides[] => {
  const filteredDevices: ISlides[] = [];

  const organizeItem = (device: ITechnology) => ({
    title: device?.card?.title || '',
    description: device?.card?.description || '',

    id: +device?.id,
    image: device?.card?.image || '',
    showInfoLine: false,
    action: {
      title: device?.card?.buttonLabel || '',
      descriptionModal: device?.detail?.description?.textHtml || '',
    },
    detail: device.detail,
  });

  if (aemTechnologyData) {
    filteredDevices.push({
      title: aemTechnologyData?.technology?.card?.title || '',
      description: aemTechnologyData?.technology?.card?.description || '',

      id: +aemTechnologyData?.technology?.id,
      image: aemTechnologyData?.technology?.card?.image || '',
      showInfoLine: true,
      action: {
        title: aemTechnologyData?.technology?.card?.buttonLabel || '',
        descriptionModal: aemTechnologyData?.technology?.detail?.description?.textHtml || '',
      },
    });
  }
  return filteredDevices;
};

